import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export async function fetchConfig() {
  const { data } = await api.get("/config");
  return data;
}

export async function fetchCategories() {
  const { data } = await api.get("/categories");
  return data;
}

export async function fetchTemplates(categoryId) {
  const { data } = await api.get(`/templates/${categoryId}`);
  return data;
}

export async function generatePrompt(payload) {
  const { data } = await api.post("/generate", payload);
  return data;
}

export async function startSession(deviceId) {
  const { data } = await api.post("/session", { device_id: deviceId });
  return data;
}

export async function claimAccess(email, deviceId) {
  const { data } = await api.post("/access/claim", { email, device_id: deviceId });
  return data;
}
